import {
  CalendarCustomToolbarWithoutViewSelection,
  StaffAttendanceOrLeaveModal,
  CustomTable,
} from "components";
import { useReducer, useMemo, useState, useCallback } from "react";
import { Calendar } from "react-big-calendar";
import { firstDay, lastDay } from "utils/dateHelper";
import { useQuery } from "react-query";
import { CustomTabs } from "components";
import apiService from "services/api";
import { initialModalState, modalActions, modalReducer } from "./reducers";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import {
  eventColors,
  transformAttendance,
  transformLeaves,
  leaveTableColumns,
  otTableColumns,
  myLessonRecordsTableColumn,
} from "./constants";
import { Row, Col, Container } from "reactstrap";
import { Profile } from "./Profile";

const localizer = momentLocalizer(moment);

const MyDashboard = () => {
  const { data: staff, isLoading } = useQuery(["staff", "self"], () =>
    apiService.staff.self(),
  );

  const [currentDate, setCurrentDate] = useState(new Date());
  const [queryDateRange, setQueryDateRange] = useState({
    start: firstDay(),
    end: lastDay(),
  });

  const { data: attendanceRecords, isLoading: isLoadingAttendanceRecords } =
    useQuery(
      ["attendanceRecords", queryDateRange.start, queryDateRange.end],
      () =>
        apiService.selfV2.attendances({
          date_from: moment(queryDateRange.start).format("YYYY-MM-DD"),
          date_to: moment(queryDateRange.end).format("YYYY-MM-DD"),
        }),
    );

  const { data: applications, isLoading: isLoadingApplications } = useQuery(
    ["applications", queryDateRange.start, queryDateRange.end],
    () =>
      apiService.selfV2.applications({
        date_from: moment(queryDateRange.start).format("YYYY-MM-DD"),
        date_to: moment(queryDateRange.end).format("YYYY-MM-DD"),
      }),
  );

  const [state, dispatch] = useReducer(modalReducer, initialModalState);

  const displayAttendanceDetails = (event) => {
    dispatch({ type: modalActions.OPEN, payload: event });
  };

  const events = useMemo(() => {
    return [
      ...transformAttendance(attendanceRecords ?? []),
      ...transformLeaves(applications ?? []),
    ];
  }, [attendanceRecords, applications]);

  const handleNavigate = useCallback(
    (date) => {
      let [start, end] = [firstDay(date, "month"), lastDay(date, "month")];
      setCurrentDate(date);
      const newStart = moment(start).unix();
      const newEnd = moment(end).unix();
      const currStart = moment(queryDateRange.start).unix();
      const currEnd = moment(queryDateRange.end).unix();
      if (newStart >= currStart && newEnd <= currEnd) {
        return;
      }
      return setQueryDateRange({ start, end });
    },
    [queryDateRange],
  );

  const tabs = useMemo(
    () => [
      {
        title: "Dashboard",
        component: () => (
          <Container fluid>
            <Row className="pb-5">
              <h3>My Dashboard</h3>
              <StaffAttendanceOrLeaveModal state={state} dispatch={dispatch} />
              <div className="col-12" style={{ height: 500 }}>
                <Calendar
                  selectable
                  localizer={localizer}
                  longPressThreshold={200}
                  events={events}
                  defaultView="month"
                  defaultDate={new Date()}
                  date={currentDate}
                  onNavigate={handleNavigate}
                  eventPropGetter={eventColors}
                  onSelectEvent={displayAttendanceDetails}
                  dayLayoutAlgorithm="no-overlap"
                  components={{
                    toolbar: CalendarCustomToolbarWithoutViewSelection,
                  }}
                  popup
                  messages={{
                    showMore: (total) => (
                      <div
                        style={{ cursor: "pointer" }}
                        className="text-center"
                        onMouseOver={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {`+${total}`}
                      </div>
                    ),
                  }}
                />
              </div>
            </Row>
            {/* <Row> */}
            {/*   <Col md="12"> */}
            {/*     <CustomTable */}
            {/*       data={staff?.lessonRecords.filter( */}
            {/*         (lesson) => !lesson.isCancelled, */}
            {/*       )} */}
            {/*       columns={myLessonRecordsTableColumn} */}
            {/*       defaultPageSize={10} */}
            {/*       title={"My Lesson Records"} */}
            {/*       loading={isLoading} */}
            {/*     /> */}
            {/*   </Col> */}
            {/* </Row> */}
            {/* <Row> */}
            {/*   <Col md="6"> */}
            {/*     <CustomTable */}
            {/*       data={staff?.applications.filter((appl) => !appl.isOt)} */}
            {/*       columns={leaveTableColumns} */}
            {/*       defaultPageSize={10} */}
            {/*       title={"My Leaves"} */}
            {/*       loading={isLoading} */}
            {/*     /> */}
            {/*   </Col> */}
            {/*   <Col md="6"> */}
            {/*     <CustomTable */}
            {/*       data={staff?.applications.filter((appl) => appl.isOt)} */}
            {/*       columns={otTableColumns} */}
            {/*       defaultPageSize={10} */}
            {/*       title={"My OTs"} */}
            {/*       loading={isLoading} */}
            {/*     /> */}
            {/*   </Col> */}
            {/* </Row> */}
          </Container>
        ),
      },
      {
        title: "My Statistics",
        component: () => <Profile staff={staff} />,
      },
    ],
    [state, events, currentDate, handleNavigate, staff],
  );

  return (
    <div className="content">
      <CustomTabs tabs={tabs} />
    </div>
  );
};

export default MyDashboard;
